const API_V1_PREFIX = '/api/v1'

export const API_AUTH_LOGIN_URL = `${API_V1_PREFIX}/auth/login`
export const API_AUTH_LOGOUT_URL = `${API_V1_PREFIX}/auth/logout`
export const API_AUTH_SESSION_URL = `${API_V1_PREFIX}/auth/session`
export const API_AUTH_TERMS_CURRENT_URL = `${API_V1_PREFIX}/auth/terms/current`
export const API_AUTH_TERMS_ACCEPT_URL = `${API_V1_PREFIX}/auth/terms/accept`
export const API_COMPANY_PROFILE_URL = `${API_V1_PREFIX}/company/profile`
export const API_COMPANY_DASHBOARD_STATS_URL = `${API_V1_PREFIX}/company/dashboard-stats`
export const API_COMPANY_PREVIEW_URL = `${API_V1_PREFIX}/company/preview`
export const API_COMPANY_PROFILE_PUBLISH_URL = `${API_V1_PREFIX}/company/profile/publish`
export const API_PROFESSIONS_URL = `${API_V1_PREFIX}/professions`
export const API_COMPANY_UPLOAD_URL = `${API_V1_PREFIX}/company/upload`

export const API_ADMIN_COMPANIES_URL = `${API_V1_PREFIX}/admin/companies`
export const apiAdminCompanyProfileUrl = (organizationId: string) =>
    `${API_V1_PREFIX}/admin/companies/${organizationId}/profile`
export const apiAdminCompanyPublishUrl = (organizationId: string) =>
    `${API_V1_PREFIX}/admin/companies/${organizationId}/publish`
export const apiAdminCompanyDashboardStatsUrl = (organizationId: string) =>
    `${API_V1_PREFIX}/admin/companies/${organizationId}/dashboard-stats`
export const apiAdminCompanyPreviewUrl = (organizationId: string) =>
    `${API_V1_PREFIX}/admin/companies/${organizationId}/preview`
